export default __webpack_public_path__ + "static/media/menu.2add06cc.svg";